module.exports = __webpack_public_path__ + "assets/webgl/LM_3_0.9a1da2dc.jpg";